import { dateFromDateStringWithAppendedTime } from '@/utils/dates';

export const isInsurancePolicyExpired = (planEndDate: string | null | undefined): boolean => {
  if (!planEndDate) return false;

  const endOfPlanEndDate = dateFromDateStringWithAppendedTime(planEndDate);
  endOfPlanEndDate.setHours(23, 59, 59, 999);

  return endOfPlanEndDate < new Date();
};
